const getTagValue = (tags, tagName, separator, defaultValue = null) => {
    if (!tags) return defaultValue;
    const tag = tags.find(e => e.startsWith(tagName));
    if (!tag) return defaultValue;
    return tag.replace(`${tagName}${separator}`, '');
}

export default getTagValue;